import { render } from "./descriptionsLhl.vue?vue&type=template&id=ec59c534&scoped=true&ts=true"
import script from "./descriptionsLhl.vue?vue&type=script&lang=ts"
export * from "./descriptionsLhl.vue?vue&type=script&lang=ts"

import "./descriptionsLhl.vue?vue&type=style&index=0&id=ec59c534&scoped=true&lang=css"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec59c534"]])

export default __exports__